<template>
<span>

    <v-card v-if="loggedUser" class="pa-6 ma-md-10 bg-white-show-through">

        <v-card-title class="card-title">
            <v-icon large class="indigo--text mr-3">{{$t('client.account.icon')}}</v-icon>Check-in Informations
        </v-card-title>

        <v-card-text>
            <UserExtratInfo v-bind:user="loggedUser"></UserExtratInfo>
             <div class="text-center">
                    <v-btn rounded color="primary" type="submit" @click="update()" style="text-align: center">
                            &nbsp;{{$t('shared.update')}}
                </v-btn>
                </div>
        </v-card-text>


      <v-divider class="my-4"></v-divider>
    <FilesPermis></FilesPermis>

    </v-card>


</span>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { UsersApi } from '../../../shared/services/api'
  import FilesPermis from '../components/FilesPermis'

  export default {
    name: 'Account',
    components: { FilesPermis },
    data () {
      return {

      }
    },
    methods: {
      update () {

          UsersApi.updateUser(this.loggedUser).then(data => {
            // succes message
            this.$root.bar.success({ message: i18n.t('shared.updateCorrect') })
          }).catch(error => {
            this.$root.bar.error({ message: error })
          })

        }
    },
    created: function () {

    },
    computed: {
      ...mapGetters({ loggedUser: 'main/loggedUser' })
    }
  }
</script>
